<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'home.paycards.details.title' | translate }}
      {{ paycardId }}
    </h5>
    <div class="buttons">
      <button class="btn btn-warning" type="button" (click)="onResetPin(paycardId)">{{ 'home.paycards.details.buttons.reset' | translate }}</button>
      <button class="btn btn-danger" type="button" (click)="onDeletePaycard(paycardId)"><i class="fas fa-trash-alt"></i></button>
    </div>
  </div>
  <div class="modal-body" *ngIf="paycard">
    <table class="detail-table">
      <tr>
        <td>{{ 'home.paycards.details.status' | translate }}</td>
        <td>{{ paycard.status }}</td>
      </tr>
      <tr *ngIf="paycard.accessId">
        <td>{{ 'home.paycards.details.accessId' | translate }}</td>
        <td>{{ paycard.accessId }}</td>
      </tr>
      <tr>
        <td>{{ 'home.paycards.details.created' | translate }}</td>
        <td>{{ paycard.created | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>
      <tr>
        <td>{{ 'home.paycards.details.updated' | translate }}</td>
        <td>{{ paycard.updated | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>

      <tr>
        <td colspan="2">
          <hr
            *ngIf="paycard.edition != null || paycard.webChargeAllowed != null || paycard.deleted != null || paycard.active != null">
        </td>
      </tr>

      <tr>
        <td>{{ 'home.paycards.details.edition' | translate }}</td>
        <td>{{ paycard.edition }}</td>
      </tr>
      <tr>
        <td>{{ 'home.paycards.details.webChargeAllowed' | translate }}</td>
        <td>{{ paycard.webChargeAllowed }}</td>
      </tr>
      <tr>
        <td>{{ 'home.paycards.details.deleted' | translate }}</td>
        <td>{{ paycard.deleted }}</td>
      </tr>
      <tr>
        <td>{{ 'home.paycards.details.active' | translate }}</td>
        <td>{{ paycard.active }}</td>
      </tr>

      <tr>
        <td colspan="2">
          <hr
            *ngIf="paycard.chargeFrom != null || paycard.chargeTo != null || paycard.returnTo != null || paycard.paymentTo != null">
        </td>
      </tr>

      <tr *ngIf="paycard.chargeFrom != null">
        <td>{{ 'home.paycards.details.chargeFrom' | translate }}</td>
        <td>{{ paycard.chargeFrom | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>
      <tr *ngIf="paycard.chargeTo != null">
        <td>{{ 'home.paycards.details.chargeTo' | translate }}</td>
        <td>{{ paycard.chargeTo | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>
      <tr *ngIf="paycard.paymentTo != null">
        <td>{{ 'home.paycards.details.paymentTo' | translate }}</td>
        <td>{{ paycard.paymentTo | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>
      <tr *ngIf="paycard.returnTo != null">
        <td>{{ 'home.paycards.details.returnTo' | translate }}</td>
        <td>{{ paycard.returnTo | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      </tr>

      <tr>
        <td colspan="2">
          <hr
            *ngIf="paycard.balance != null || paycard.balance_webcharge != null || paycard.balance_card != null || paycard.minCardLimit != null || paycard.maxCardLimit != null">
        </td>
      </tr>

      <tr *ngIf="paycard.balance != null">
        <td>{{ 'home.paycards.details.balance' | translate }}</td>
        <td>{{ paycard.balance / 100 | currency:paycard.currency }}</td>
      </tr>
      <tr *ngIf="paycard.balance_webcharge != null">
        <td>{{ 'home.paycards.details.balance_webcharge' | translate }}</td>
        <td>{{ paycard.balance_webcharge / 100 | currency:paycard.currency }}</td>
      </tr>
      <tr *ngIf="paycard.balance_card != null">
        <td>{{ 'home.paycards.details.balance_card' | translate }}</td>
        <td>{{ paycard.balance_card / 100 | currency:paycard.currency }}</td>
      </tr>
      <tr *ngIf="paycard.minCardLimit != null">
        <td>{{ 'home.paycards.details.minCardLimit' | translate }}</td>
        <td>{{ paycard.minCardLimit / 100 | currency:paycard.currency }}</td>
      </tr>
      <tr *ngIf="paycard.maxCardLimit != null">
        <td>{{ 'home.paycards.details.maxCardLimit' | translate }}</td>
        <td>{{ paycard.maxCardLimit / 100 | currency:paycard.currency }}</td>
      </tr>

    </table>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" ngbAutofocus type="button" (click)="onCloseModal()">
      {{ 'home.paycards.details.buttons.close' | translate }}
    </button>
  </div>
</div>
